import React from "react";
import TextArea from "../Inputs/TextArea";
import FileUpload from "../Upload/FileUpload";
import UploadedFileList from "../Upload/UploadedFileList";
import "../../../css/Recruitment/Sections.css";

const SectionAdditionalInfo = ({
  sectionNumber,
  formData,
  errors,
  showErrors,
  isSubmitted,
  onTextChange,
  onFileChange,
  onFileRemove,
}) => {
  const fileKey = `files_${sectionNumber}`;
  const infoKey = `additionalInformation_${sectionNumber}`;

  return (
    <div>
      <div className="sizebox" />
      <div className="Content-Bold-Underline">
        Please provide full details below:
      </div>
      <TextArea
        name={infoKey}
        placeholder="Enter your text here..."
        value={formData[infoKey] || ""}
        onChange={onTextChange}
        readOnly={isSubmitted}
        error={errors[infoKey]}
        showError={showErrors}
        rows={6}
      />
      <div className="sizebox" />

      <FileUpload
        description="Drag & drop files here or"
        browseText="Browse"
        onDrop={(e) => onFileChange(fileKey, e)}
        onBrowse={() =>
          document.getElementById(`fileInput_${sectionNumber}`).click()
        }
      />
      <input
        type="file"
        multiple
        onChange={(e) => onFileChange(fileKey, e)}
        style={{ display: "none" }}
        id={`fileInput_${sectionNumber}`}
      />

      {(formData[fileKey] || []).length > 0 && (
        <UploadedFileList
          files={formData[fileKey]}
          onRemove={(file, index) =>
            onFileRemove(fileKey, (formData[fileKey] || []).indexOf(file))
          }
        />
      )}
    </div>
  );
};

export default SectionAdditionalInfo;
